// extracted by mini-css-extract-plugin
export default {"AppMenuButton":"UserHeader_AppMenuButton__oSAB3","tabs_area":"UserHeader_tabs_area__-b68L","scroll":"UserHeader_scroll__auqjc","searchIcon":"UserHeader_searchIcon__22pl1"};